import { render, staticRenderFns } from "./Proprietaire.vue?vue&type=template&id=47a488f4&scoped=true&"
import script from "./Proprietaire.vue?vue&type=script&lang=js&"
export * from "./Proprietaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a488f4",
  null
  
)

export default component.exports